export const COMPOUND_INDEPENDENT_ID = 'student.compoundIndependent';

export interface DependencyCriterion {
  questionId: string;
  label: string;
}

/** Gateway checklist: each row maps to one dependency input question. */
export const DEPENDENCY_CRITERIA: readonly DependencyCriterion[] = [
  { questionId: 'student.birthYear', label: 'I am 24 or older' },
  { questionId: 'student.maritalStatusCode', label: 'I am married, separated, or divorced' },
  { questionId: 'student.hasDependentsIndicator', label: 'I have children or other dependents I support' },
  { questionId: 'student.veteranIndicator', label: 'I am a veteran of the U.S. Armed Forces' },
  { questionId: 'student.orphanIndicator', label: 'I was in foster care or a ward of the court after age 13' },
  { questionId: 'student.emancipatedMinor', label: 'I am an emancipated minor' },
  { questionId: 'student.homelessIndicator', label: 'I am or was homeless' },
];

export const DEPENDENCY_INPUT_IDS = DEPENDENCY_CRITERIA.map(c => c.questionId);

/** Collected on Student Finances instead of the gateway page. */
export const STUDENT_FINANCES_PROFILE_IDS = [
  'student.birthYear',
  'student.maritalStatusCode',
] as const;

/**
 * Questions shown on the Household page (HP) for the student-only path when present.
 * Restored to their prepared/Firestore section on the dependent path.
 */
export const INDEPENDENT_HOUSEHOLD_PROFILE_IDS = [
  'student.birthYear',
  'student.residencyStateCode',
  'student.maritalStatusCode',
  'student.siblingCount',
  'student.siblingCollegeCount',
] as const;

export const GATEWAY_YES_NO_IDS = DEPENDENCY_CRITERIA
  .map(c => c.questionId)
  .filter(id => !(STUDENT_FINANCES_PROFILE_IDS as readonly string[]).includes(id));

export function isGatewayCriterionSelected(
  questionId: string,
  getAnswer: (id: string) => string,
  isOlderThan24: () => boolean,
  gatewaySelectedCriteria: readonly string[],
): boolean {
  if (gatewaySelectedCriteria.includes(questionId)) {
    return true;
  }
  if (GATEWAY_YES_NO_IDS.includes(questionId)) {
    return getAnswer(questionId) === 'yes';
  }
  if (questionId === 'student.birthYear') {
    return isOlderThan24();
  }
  if (questionId === 'student.maritalStatusCode') {
    return getAnswer(questionId) === '2';
  }
  return false;
}
